import * as React from 'react';
import styled from 'styled-components';

import { getColor, getFontSize } from '@process-advisor/process-miner/shared/theme';
import { Switch, type SwitchProps } from '@process-advisor/process-miner/components/shared/switch';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

const Title = styled.div`
    font-size: ${getFontSize('smaller')};
    color: ${getColor('blue')};
    margin-bottom: 5px;
`;

const StyledSwitch = styled(Switch)`
    color: ${getColor('blue')};
    margin-left: 0;

    & .MuiFormControlLabel-label {
        font-size: ${getFontSize('smaller')};
    }
`;

const Content = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 3px;
    font-size: ${getFontSize('smaller')};
    color: ${getColor('inputTextColor')}
`;

type Props = {
    title: string;
    switchProps?: Omit<SwitchProps, 'label'>;
}

export const Section: React.FC<Props> = ({
    children,
    title,
    switchProps,
}) => (
    <Wrapper>
        {
            switchProps
                ? <StyledSwitch label={title} {...switchProps} />
                : <Title>{title}</Title>
        }
        <Content>{children}</Content>
    </Wrapper>
);
